/* Slider List */
function sliderli(callback, append) {
    var sliderlist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + callback + '.jsonp',
        type: "GET",
        dataType: "jsonp",
        jsonpCallback: callback,
        error: function() {
            // エラーハンドリング
        },
        success: function(json) {
            var len = json.length;
            for (var i = 0; i < len; i++) {
                if (json[i].url_o) { // json[i].url_oが存在する場合のみ処理を続行
                    sliderlist = `
                    <div class="mv-slide swiper-slide">
                        <a href="${json[i].url_o}"><img src="${json[i].img}" alt="${json[i].name}" width="1500" height="1000"></a>
                    </div>`;
                    $(append).append(sliderlist);
                }
            }

            // Swiperの初期化
            var swiper = new Swiper('.mv-slider', {
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                spaceBetween: 0,
                autoplay: { // 自動再生
                  delay: 3000, // 3秒後に次のスライド
                },
                breakpoints: {
                    769: {
                        spaceBetween: 0,
                        slidesPerView: 2.5,
                    },
                }
            });
        }
    });
}

/* 記入例：実行関数('jsonpのファイル名','掃き出し先id') */
$(function(){
    sliderli('s_top_slider','.mv-slider__inner');
});

/* Slider List */
function sliderli2(callback, append) {
    var sliderlist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + callback + '.jsonp',
        type: "GET",
        dataType: "jsonp",
        jsonpCallback: callback,
        error: function() {
            // エラーハンドリング
        },
        success: function(json) {
            var len = json.length;
            for (var i = 0; i < len; i++) {
                if (json[i].url_o) { // json[i].url_oが存在する場合のみ処理を続行
                    sliderlist = `
                    <div class="convey-slide swiper-slide">
                        <a href="${json[i].url_o}">
                            <img src="${json[i].img}" alt="${json[i].name}" width="1534" height="712" loading="lazy">
                        </a>
                    </div>
                    `;
                    $(append).append(sliderlist);
                }
            }

            // Swiperの初期化
            var swiper = new Swiper('.convey-slider', {
                slidesPerView: 1,
                spaceBetween: 15,
                centeredSlides: true,
                loop: true,
                autoplay: { // 自動再生
                  delay: 3000, // 3秒後に次のスライド
                },
                breakpoints: {
                    769: {
                        spaceBetween: 25,
                        slidesPerView: 2.8,
                    },
                }
            });
        }
    });
}

/* 記入例：実行関数('jsonpのファイル名','掃き出し先id') */
$(function(){
    sliderli2('s_second_slider','.convey-slide__wrapper');
});

document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById('openNotice');
  const modal = document.getElementById('noticeModal');
  const closeOverlay = document.getElementById('closeNotice');
  const closeBtn = document.getElementById('closeNoticeBtn');

  if (!openBtn || !modal) return;

  openBtn.addEventListener('click', () => {
    modal.style.display = 'block';
  });

  [closeOverlay, closeBtn].forEach(el => {
    el.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  });
});
